import useAxios from '../hooks/useAxios';
import {RECOMMENDED_PRODUCTS_URL} from './constants';

/**
 * Hook for interacting with the Products API.
 *
 * @returns {Object} An object containing functions to interact with the API.
 */
export const useProductsApi = () => {
  console.log("RECOMMENDED_PRODUCTS_URL:", RECOMMENDED_PRODUCTS_URL);
  const api = useAxios();

  const createProductRecommendation = async (assessmentId,userCountryLocation) => {
    try {
      const response = await api.post(`${RECOMMENDED_PRODUCTS_URL}/${assessmentId}?country=${userCountryLocation}`);
      return response;
    } catch (error) {
      console.error("Error in createProductRecommendation:", error.response?.data || error.message);
      throw error;
    }
  };

  const getRecommendedProducts = async (assessmentId) => {
    try {
      const response = await api.get(`${RECOMMENDED_PRODUCTS_URL}/${assessmentId}`);
      return response;
    } catch (error) {
      console.error("Error in getRecommendedProducts:", error.response?.data || error.message);
      throw error;
    }
  };

  return {
    createProductRecommendation,
    getRecommendedProducts
  };
};
